import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MasterdataService } from '../../services/APIs/MasterData/masterdata.service';
import { PreferencesService } from '../../services/APIs/Preferences/preferences.service';
import { DataContextService } from '../../services/datacontext.service';
import { PreferencesConfigService } from '../../services/preferences/preferences-config.service';
import { PreferencesCurrentViewService } from '../../services/preferences/preferences-current-view';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.less'],
  providers: [PreferencesService]
})
export class LayoutComponent implements OnInit {
  
  constructor(private masterDataService: MasterdataService,
    private _hotelingDataService: DataContextService,
    private preferenceService: PreferencesService,
    private preferencesConfigService: PreferencesConfigService,
    private preferencesCurrentViewService: PreferencesCurrentViewService) {
    preferenceService.languageChanged$.subscribe(value => {
      if (value) {
        this.getMasterData();
        this.preferenceService.languageChanged$.next(false);
      }  
    })
  }

  ngOnInit(): void {
  this.getMasterData();
  }
  private getMasterData() {
    //Phase -1 - Removed preferred language call
        forkJoin([
          this.masterDataService.getMasterData(),
          this.preferencesConfigService.getConfig(),
        ])
          .subscribe(res => {
            DataContextService.TimeZones = res[0].TimeZones;
            // DataContextService.VirtualBookingTechnologyAccounts = res[0].VirtualBookingTechnologyAccounts;
            // DataContextService.VirtualBookingAdditionalDetails = res[0].VirtualBookingAdditionalDetails;
            DataContextService.TaskTypes = res[0].TaskTypes;
            DataContextService.ServiceOrderTypes = res[0].ServiceOrderTypes;
            // DataContextService.Neighborhoods = res[0].Neighborhoods;
            DataContextService.Series = res[0].Series;
            DataContextService.TaskStatus = res[0].TaskStatuses;
            DataContextService.CateringStatus = res[0].CateringStatuses;
            DataContextService.WaitlistStatus = res[0].WaitlistStatuses;
            DataContextService.BookingStatus = res[0].BookingStatus;
            DataContextService.ReservationStatus = res[0].ReservationStatus;
            // DataContextService.VirtualBookingStatus = res[0].VirtualBookingStatus;
            DataContextService.SpaceFeatures = res[0].SpaceFeatures;
            DataContextService.EventTypes = res[0].EventTypes;
            DataContextService.SpaceSetupTypes = res[0].SpaceSetupTypes;
            DataContextService.Configurations = res[0].Configurations;
            this.mapConfigurationSettings(res[0].Configurations);
            DataContextService.MeetingWaitlistRequestTypes = res[0].MeetingWaitListRequestTypes;
            DataContextService.MeetingWaitlistStatus = res[0].MeetingWaitListStatuses;
            // DataContextService.AttachmentFileExtensions = res[0].AttachmentFileExtensions;
            // DataContextService.AttachmentFileTypes = res[0].AttachmentFIleTypes;
            DataContextService.StatusReasons = res[0].StatusReasons;
            DataContextService.SpaceSubTypes = res[0].SpaceSubTypes;
            DataContextService.Amenities = res[0].Amenities;
            DataContextService.JobTitles = res[0].JobTitles;
            DataContextService.MealOptions = res[0].MealOptions;
            DataContextService.MemberFirmConfigurations = res[0].MemberFirmConfigurations;
            DataContextService.Buildings = res[0].Buildings;
            DataContextService.SpaceTypes = res[0].SpaceTypes;
            this.preferencesCurrentViewService.setupCurrentView();
            this._hotelingDataService.masterDadaLoaded$.next(true);
          });
    };

  mapConfigurationSettings(res) {
    DataContextService.CateringOrder_Type = this.checkIfPropertyExist(res,'CateringOrderType') ? JSON.parse(res.find((item) => item.name == 'CateringOrderType').value) : null;
    DataContextService.ServiceOrderFilter_arr = this.checkIfPropertyExist(res,'ServiceOrderTypes') ? JSON.parse(res.find((item) => item.name == 'ServiceOrderTypes').value) : null;
    DataContextService.VirtualBookingTechnologyTypes = this.checkIfPropertyExist(res,'VirtualBookingTechnologies') ? JSON.parse(res.find((item) => item.name == 'VirtualBookingTechnologies').value) : null;
}
  checkIfPropertyExist(data , propertyName): boolean {
      if (data.find(item => item.name == propertyName))
          return true;
      else
          return false;
  }
  getPreferredLanguage() {
    return this._hotelingDataService.getData('Language/PreferedLanguage', false).pipe(
     tap((res) => {
      if (res.status == 200 && res.data) {
        this._hotelingDataService.setDefaultLanguage(res.data.locale);
        this._hotelingDataService.languageId = res.data.id;
        this._hotelingDataService.languageCode = JSON.stringify(res.data.code);
      }
    }));
  }
}
